import { IBaseParams } from '@interfaces/IBaseParam';
import { callAPIContent } from '@utils/fetcher/content';

export const getNotificationsFromAPI = (params: IBaseParams) => {
  const options = {
    method: 'GET',
    servicePath: 'notifications',
    uri: '',
    params,
  };
  return callAPIContent(options);
};

export const getNotificationCountFromAPI = () => {
  const options = {
    method: 'GET',
    servicePath: 'notifications',
    uri: 'count',
    params: {},
  };
  return callAPIContent(options);
};

export const markNotificationsReadFromAPI = () => {
  const options = {
    method: 'POST',
    servicePath: 'notifications',
    uri: 'read',
    params: {},
  };
  return callAPIContent(options);
};

export const markNotificationReadByIdFromAPI = (id: string) => {
  const options = {
    method: 'POST',
    servicePath: 'notifications',
    uri: `${id}/read`,
    params: {},
  };
  return callAPIContent(options);
};
